export const FETCH_IMAGES_REQUEST = 'SearchResults.FETCH_IMAGES_REQUEST'

export const FETCH_IMAGES_SUCCESS = 'SearchResults.FETCH_IMAGES_SUCCESS'
